import { Button, Form, Input } from "antd";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../app/store";
import CheckIcon from "../../../assets/icons/CheckIcon";
import {
  useLazyOldSiteVerifyEmailQuery,
  useLazyTopupPortalQuery,
  useOldSiteSendVerificationQuery,
} from "../../../features/oldSite/oldSiteApi";
import useError from "../../../hooks/useError";
import { toast } from "../../../lib/toast";
import { CustomModalProps } from "../../../types";
import { emailToShortCode } from "../../../utils/utils";
import CustomModal from "../../ui/CustomModal";
import Loader from "../../ui/Loader";

export default function TopUp({ handleClose, ...rest }: CustomModalProps) {
  const { authInfo, access_token } = useAppSelector((state) => state.auth);
  const [isSend, setIsSend] = useState(true);
  const {
    isError: isSendError,
    error: sendError,
    isLoading: isSendLoading,
    isSuccess: isSendSuccess,
    refetch,
    data: sendData,
  } = useOldSiteSendVerificationQuery({
    params: {
      token: access_token!,
    },
  });
  const [oldSiteVerifyEmail, { isError, isSuccess, isLoading, error, data }] =
    useLazyOldSiteVerifyEmailQuery();
  const [
    topupPortal,
    {
      isError: isTopupError,
      error: topupError,
      isSuccess: isTopupSuccess,
      data: topupData,
    },
  ] = useLazyTopupPortalQuery();
  useError(isSendError, sendError, "OTP send fail");
  useError(isError, error, "OTP verification fail");
  useError(isTopupError, topupError, "Topup token get fail");

  const onFinish = ({ otp }: { otp: number }) => {
    oldSiteVerifyEmail({
      params: {
        code: otp,
        token: access_token!,
      },
    });
  };

  useEffect(() => {
    if (isSuccess) {
      if (data?.code === 200) {
        topupPortal({ params: { token: access_token! } });
      } else {
        toast("error", data?.message);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, data?.code, data?.message]);

  useEffect(() => {
    if (isTopupSuccess) {
      const url = `https://topup.sheba.xyz/topup?token=${topupData?.verification_token}`;
      const topUrlLink = document.createElement("a");
      topUrlLink.setAttribute("href", url);
      topUrlLink.setAttribute("target", "_blank");
      topUrlLink.click();
      handleClose && handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTopupSuccess, topupData?.verification_token]);

  useEffect(() => {
    if (isSendSuccess && isSend && sendData?.code === 200) {
      toast("success", "Code send successfully");
      setIsSend(false);
    } else if (sendData?.code === 401) {
      toast("error", "Code send fail");
      handleClose && handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSend, isSendSuccess, sendData?.code]);

  useEffect(() => {
    if (isSendError) {
      handleClose && handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSendError]);

  return (
    <CustomModal title="" footer={null} handleClose={handleClose} {...rest}>
      <h6 className="text-header font-semibold text-2xl text-center mb-4">
        Verify your account
      </h6>
      <div className="flex gap-2 p-4 bg-[#dbf3f8] rounded border border-[#b6effb] mb-4">
        <div className="mt-1">
          <CheckIcon />
        </div>
        <p className="text-[#055160] flex-1 !text-base">
          A verification code is sent to your email,{" "}
          {emailToShortCode(authInfo?.email || "")} Use that code to verify your
          account
        </p>
      </div>

      {isSendLoading ? (
        <Loader />
      ) : (
        <>
          <div className="flex gap-2 p-4 bg-[#dbf3f8] rounded border border-[#b6effb] mb-4">
            <div className="mt-1">
              <CheckIcon />
            </div>
            <p className="text-[#055160] flex-1 !text-base">
              A verification code is sent to your email,{" "}
              {emailToShortCode(authInfo?.email || "")} Use that code to verify
              your account
            </p>
          </div>

          <Form
            className="custom-form"
            layout="vertical"
            requiredMark="optional"
            size="large"
            onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item
              name="otp"
              //   label="Code"
              className="mb-[18px]"
              rules={[
                {
                  required: true,
                  message: "Please enter OTP",
                },
                {
                  pattern: /^\d+$/,
                  message: "Only numerical values are allowed",
                },
              ]}
            >
              <Input
                placeholder="Enter Code"
                autoComplete="one-time-code"
                inputMode="numeric"
              />
            </Form.Item>

            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={isLoading}
              disabled={isSendLoading}
              block
              className="!bg-[#fe7235]"
            >
              Verify
            </Button>

            <div className="flex justify-center">
              <span
                className="text-accent text-center cursor-pointer font-medium mt-3"
                onClick={() => {
                  refetch();
                  setIsSend(true);
                }}
              >
                Resend Code
              </span>
            </div>
          </Form>
        </>
      )}
    </CustomModal>
  );
}
